var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g, _path32, _path33, _g2, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 125,
    viewBox: "0 0 113 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.57
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.6406 48.0332V48.9335",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0721 48.4688H74.1719",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4531 22.5254V23.4256",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9081 22.9893H80.0078",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6562 71.4395V72.6943",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2589 72.0674H82.0312",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1797 59.0801V60.335",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8018 59.707H36.5469",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8516 13.1953V14.4502",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4815 13.8223H36.2266",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72656 97V98.2549",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35646 97.627H5.10156",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.312 90.3711V91.626",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.942 90.998H102.688",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2621 62.8996C87.2621 62.4904 86.9074 62.1357 86.4982 62.1357C86.0617 62.1357 85.7344 62.4904 85.7344 62.8996C85.7344 63.3088 86.0617 63.6634 86.4982 63.6634C86.9074 63.6634 87.2621 63.3088 87.2621 62.8996Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7308 22.5246C96.7308 22.1154 96.3762 21.7607 95.967 21.7607C95.5578 21.7607 95.2031 22.1154 95.2031 22.5246C95.2031 22.9338 95.5578 23.2884 95.967 23.2884C96.3762 23.2884 96.7308 22.9338 96.7308 22.5246Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5199 59.0812C26.5199 58.672 26.1925 58.3174 25.756 58.3174C25.3468 58.3174 24.9922 58.672 24.9922 59.0812C24.9922 59.4904 25.3468 59.8451 25.756 59.8451C26.1925 59.8451 26.5199 59.4904 26.5199 59.0812Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9279 49.1495C32.9279 48.9313 32.7642 48.7676 32.546 48.7676C32.3277 48.7676 32.1641 48.9313 32.1641 49.1495C32.1641 49.3405 32.3277 49.5314 32.546 49.5314C32.7642 49.5314 32.9279 49.3405 32.9279 49.1495Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.717 8.9122C47.717 8.69395 47.5533 8.53027 47.335 8.53027C47.1441 8.53027 46.9531 8.69395 46.9531 8.9122C46.9531 9.10316 47.1441 9.29412 47.335 9.29412C47.5533 9.29412 47.717 9.10316 47.717 8.9122Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08416 87.4522C9.08416 87.234 8.92048 87.0703 8.70224 87.0703C8.48399 87.0703 8.32031 87.234 8.32031 87.4522C8.32031 87.6705 8.48399 87.8342 8.70224 87.8342C8.92048 87.8342 9.08416 87.6705 9.08416 87.4522Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3225 99.8097C98.3225 99.6187 98.1588 99.4277 97.9406 99.4277C97.7496 99.4277 97.5859 99.6187 97.5859 99.8097C97.5859 100.028 97.7496 100.192 97.9406 100.192C98.1588 100.192 98.3225 100.028 98.3225 99.8097Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9904 53.1075C85.9904 52.9166 85.8267 52.7256 85.6085 52.7256C85.4175 52.7256 85.2266 52.9166 85.2266 53.1075C85.2266 53.3258 85.4175 53.4894 85.6085 53.4894C85.8267 53.4894 85.9904 53.3258 85.9904 53.1075Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8498 84.1778C59.8498 83.9596 59.6861 83.7959 59.4679 83.7959C59.2769 83.7959 59.0859 83.9596 59.0859 84.1778C59.0859 84.3688 59.2769 84.5598 59.4679 84.5598C59.6861 84.5598 59.8498 84.3688 59.8498 84.1778Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M103.99 43.2325C103.99 43.0143 103.827 42.8506 103.608 42.8506C103.39 42.8506 103.227 43.0143 103.227 43.2325C103.227 43.4235 103.39 43.6144 103.608 43.6144C103.827 43.6144 103.99 43.4235 103.99 43.2325Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M75.592 12.9503C75.592 12.732 75.401 12.5684 75.21 12.5684C74.9918 12.5684 74.8281 12.732 74.8281 12.9503C74.8281 13.1412 74.9918 13.3322 75.21 13.3322C75.401 13.3322 75.592 13.1412 75.592 12.9503Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9201 36.2198C72.9201 36.0016 72.7564 35.8379 72.5382 35.8379C72.3199 35.8379 72.1562 36.0016 72.1562 36.2198C72.1562 36.4381 72.3199 36.6017 72.5382 36.6017C72.7564 36.6017 72.9201 36.4381 72.9201 36.2198Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3029 62.9005C73.3029 62.6822 73.1392 62.5186 72.921 62.5186C72.7027 62.5186 72.5391 62.6822 72.5391 62.9005C72.5391 63.1187 72.7027 63.2824 72.921 63.2824C73.1392 63.2824 73.3029 63.1187 73.3029 62.9005Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3732 86.252C17.3732 86.0338 17.2095 85.8701 16.9913 85.8701C16.7731 85.8701 16.6094 86.0338 16.6094 86.252C16.6094 86.443 16.7731 86.634 16.9913 86.634C17.2095 86.634 17.3732 86.443 17.3732 86.252Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14666 72.5577C4.14666 72.3395 3.98298 72.1758 3.76474 72.1758C3.54649 72.1758 3.38281 72.3395 3.38281 72.5577C3.38281 72.7487 3.54649 72.9396 3.76474 72.9396C3.98298 72.9396 4.14666 72.7487 4.14666 72.5577Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M112.123 87.0704C112.123 86.8522 111.96 86.6885 111.741 86.6885C111.55 86.6885 111.359 86.8522 111.359 87.0704C111.359 87.2886 111.55 87.4523 111.741 87.4523C111.96 87.4523 112.123 87.2886 112.123 87.0704Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4357 68.9288C39.4357 68.7106 39.272 68.5469 39.0538 68.5469C38.8356 68.5469 38.6719 68.7106 38.6719 68.9288C38.6719 69.147 38.8356 69.3107 39.0538 69.3107C39.272 69.3107 39.4357 69.147 39.4357 68.9288Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81071 30.6819C3.601 34.8012 0 36.1107 0 36.1107C0 36.1107 2.91899 38.675 4.11933 41.8668C5.01958 38.0476 9.2753 35.6196 10.3392 31.7458C9.41171 29.1269 7.03832 26.999 6.9292 26.7535C6.84736 27.9266 6.60183 29.2633 5.81071 30.6819ZM6.9292 26.7535C7.03832 26.999 9.41171 29.1269 10.3392 31.7458C10.7484 30.3 10.7484 28.6631 11.7305 27.4355C11.8578 27.2718 11.9942 27.1173 12.1397 26.9718C11.0212 24.7621 8.51146 23.0434 7.99313 22.8252C6.84736 23.2616 7.09288 24.7621 6.9292 26.7535ZM8.42962 22.716C8.26593 22.7342 8.12044 22.7706 7.99313 22.8252C8.51146 23.0434 11.0212 24.7621 12.1397 26.9718C13.0127 26.1534 14.213 25.6623 15.1951 25.0076C18.6052 22.8252 19.6418 20.5063 19.8055 16.6052C18.6597 15.2412 16.8865 14.341 15.9317 13.9318C14.6768 18.7877 10.803 22.4159 8.42962 22.716ZM16.1499 12.8406C16.0954 13.2043 16.0226 13.568 15.9317 13.9318C16.8865 14.341 18.6597 15.2412 19.8055 16.6052C20.0237 11.2037 22.5063 7.98466 21.9606 6.48425C21.6697 5.77496 21.3787 5.05658 21.0877 4.3291C21.0877 4.3291 17.0502 7.46634 16.1499 12.8406ZM4.11933 41.8668C4.58309 43.149 4.80133 44.5676 4.39213 45.9316C3.65556 48.4959 4.61037 50.4328 5.72887 52.2061C6.32903 49.9691 6.54727 47.5411 7.44752 45.386C8.37506 43.2581 10.5848 42.2487 11.7033 40.2027C11.0485 38.9751 10.5302 37.7202 10.5302 36.3016C10.5575 34.6648 10.9394 33.3554 10.3392 31.7458C9.2753 35.6196 5.01958 38.0476 4.11933 41.8668ZM11.7305 27.4355C10.7484 28.6631 10.7484 30.3 10.3392 31.7458C10.9394 33.3554 10.5575 34.6648 10.5302 36.3016C10.5302 37.7202 11.0485 38.9751 11.7033 40.2027C12.7126 38.3477 13.2855 36.4653 14.1858 34.7467C12.4671 32.3187 13.3946 29.4816 12.1397 26.9718C11.9942 27.1173 11.8578 27.2718 11.7305 27.4355ZM15.1951 25.0076C14.213 25.6623 13.0127 26.1534 12.1397 26.9718C13.3946 29.4816 12.4671 32.3187 14.1858 34.7467C15.6043 31.9641 18.4688 31.6367 21.3332 30.6819C22.5063 30.3 23.843 29.7816 24.5796 28.9359C25.5071 27.8993 25.016 27.19 24.8796 25.7169C23.5702 23.9436 21.1968 18.2966 19.8055 16.6052C19.6418 20.5063 18.6052 22.8252 15.1951 25.0076ZM19.8055 16.6052C21.1968 18.2966 23.5702 23.9436 24.8796 25.7169C24.3886 20.0426 23.843 12.2677 23.0519 9.21228C22.6881 8.30293 22.3244 7.39359 21.9606 6.48425C22.5063 7.98466 20.0237 11.2037 19.8055 16.6052ZM7.44752 45.386C6.54727 47.5411 6.32903 49.9691 5.72887 52.2061C6.68368 53.6792 7.72033 55.0705 7.99313 56.6527C8.7297 61.0994 8.10225 53.3791 10.8303 53.3518C11.1304 53.3518 11.294 53.27 11.4032 53.1336C12.1943 51.8514 6.84736 45.7952 11.8942 45.6315C13.7493 45.5497 15.277 45.1677 16.5319 44.513C16.4409 44.5858 16.2954 44.613 16.0954 44.5948C14.2403 44.1584 13.8584 46.7227 13.5856 45.2223C13.531 44.9495 13.4219 44.5403 13.3128 43.9947C13.1218 42.6852 12.3034 41.4849 11.7033 40.2027C10.5848 42.2487 8.37506 43.2581 7.44752 45.386ZM11.7033 40.2027C12.3034 41.4849 13.1218 42.6852 13.3128 43.9947C13.4219 44.5403 13.531 44.9495 13.5856 45.2223C13.8584 46.7227 14.2403 44.1584 16.0954 44.5948C16.2954 44.613 16.4409 44.5858 16.5319 44.513C18.9325 43.2308 20.2693 40.9938 20.9513 38.1567C20.8422 38.2113 20.7058 38.2385 20.4875 38.2385C18.4961 38.0748 17.6231 39.8481 16.8865 38.7023C16.7228 38.4841 16.5319 38.1567 16.3682 37.7475C15.8771 36.7381 14.8678 35.756 14.1858 34.7467C13.2855 36.4653 12.7126 38.3477 11.7033 40.2027ZM24.5796 28.9359C23.843 29.7816 22.5063 30.3 21.3332 30.6819C18.4688 31.6367 15.6043 31.9641 14.1858 34.7467C14.8678 35.756 15.8771 36.7381 16.3682 37.7475C16.5319 38.1567 16.7228 38.4841 16.8865 38.7023C17.6231 39.8481 18.4961 38.0748 20.4875 38.2385C20.7058 38.2385 20.8422 38.2113 20.9513 38.1567C20.9877 37.993 21.024 37.8293 21.0604 37.6656C22.0425 33.1098 27.0893 37.6384 33.0365 34.0101C32.6 32.9552 32.1726 31.9095 31.7543 30.8728C27.8532 29.3724 27.253 28.9359 24.8796 25.7169C25.016 27.19 25.5071 27.8993 24.5796 28.9359ZM24.8796 25.7169C27.253 28.9359 27.8532 29.3724 31.7543 30.8728C29.5537 25.3622 27.344 19.8607 25.1252 14.3683C24.4341 12.6587 23.743 10.94 23.0519 9.21228C23.843 12.2677 24.3886 20.0426 24.8796 25.7169Z",
    fill: "url(#paint0_linear_15268_36948)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15268_36948",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 0,
    width: 3,
    height: 3
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4334 2.6893L19.3379 2.44105C19.1005 1.82451 19.4088 1.13432 20.0253 0.896984C20.6419 0.662373 21.3321 0.970641 21.5694 1.58445L21.6649 1.83543L19.4334 2.6893Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15268_36948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.862 -2.87207L21.5806 1.6019C21.5806 1.6019 21.5806 1.59281 21.5806 1.57462L19.862 -2.87207ZM19.8347 -2.84479L19.6983 -2.79023L21.417 1.65646L21.5534 1.6019L19.8347 -2.84479ZM21.5261 1.62918L21.3897 1.68374L21.4988 1.92927L21.6352 1.8747L21.5261 1.62918ZM19.671 -2.79023L19.5346 -2.73567L21.2533 1.7383L21.3897 1.68374L19.671 -2.79023ZM21.3897 1.68374L21.2533 1.7383L21.3351 1.98383L21.4715 1.92927L21.3897 1.68374ZM19.5346 -2.73567L19.2618 -2.62655L20.9805 1.84742L21.2533 1.7383L19.5346 -2.73567ZM21.2533 1.71102L20.9805 1.82014L21.0623 2.06567L21.3351 1.98383L21.2533 1.71102ZM19.2618 -2.65383L18.7162 -2.43559L20.4349 2.01111L20.9805 1.79286L19.2618 -2.65383ZM20.9805 1.82014L20.4076 2.03839L20.5167 2.28391L21.0623 2.06567L20.9805 1.82014ZM18.7162 -2.43559L18.1706 -2.21734L19.8893 2.25663L20.4349 2.03839L18.7162 -2.43559ZM20.4349 2.03839L19.862 2.22935L19.9711 2.50215L20.5167 2.28391L20.4349 2.03839ZM18.1706 -2.21734L17.625 -1.9991L19.3437 2.44759L19.8893 2.25663L18.1706 -2.21734ZM19.8893 2.22935L19.3164 2.44759L19.4255 2.69311L19.9711 2.47487L19.8893 2.22935ZM17.625 -2.02638C17.625 -2.02638 17.625 -2.01729 17.625 -1.9991L19.3164 2.44759C19.3346 2.44759 19.3437 2.44759 19.3437 2.44759L17.625 -2.02638Z",
    fill: "url(#paint1_linear_15268_36948)"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5807 1.57324C21.5807 1.59143 21.5807 1.60052 21.5807 1.60052C21.6353 1.7642 21.6626 1.84605 21.6626 1.84605C21.6626 1.84605 21.6353 1.75511 21.5807 1.57324ZM21.5535 1.60052L21.4171 1.6278C21.4898 1.80967 21.5262 1.90061 21.5262 1.90061L21.6626 1.84605C21.6626 1.84605 21.6262 1.7642 21.5535 1.60052ZM21.6626 1.84605L21.5262 1.90061L56.7723 93.9444L56.936 93.8898L21.6626 1.84605ZM56.9087 93.8898L56.7723 93.9444C56.7723 93.9444 56.8087 94.0262 56.8815 94.1899L57.0179 94.1353C56.9451 93.9717 56.9087 93.8898 56.9087 93.8898ZM21.4171 1.6278L21.2807 1.68236C21.3352 1.86423 21.3625 1.95517 21.3625 1.95517L21.4989 1.90061C21.4989 1.90061 21.4716 1.80967 21.4171 1.6278ZM21.4989 1.90061L21.3625 1.95517L56.6359 93.9989L56.7723 93.9444L21.4989 1.90061ZM56.7723 93.9444L56.6359 93.9989C56.6359 93.9989 56.6632 94.0808 56.7178 94.2445L56.8542 94.1899C56.7996 94.0262 56.7723 93.9444 56.7723 93.9444ZM21.2807 1.68236L20.9806 1.79148C21.0533 1.95517 21.0897 2.03701 21.0897 2.03701L21.3625 1.95517C21.3625 1.95517 21.3352 1.86423 21.2807 1.68236ZM21.3625 1.95517L21.0897 2.03701L56.3631 94.0808L56.6359 93.9989L21.3625 1.95517ZM56.6359 93.9989L56.3359 94.0808C56.3359 94.0808 56.3722 94.1717 56.445 94.3536L56.7178 94.2445C56.6632 94.0808 56.6359 93.9989 56.6359 93.9989ZM20.9806 1.79148L20.435 2.00973C20.4895 2.17341 20.5168 2.25525 20.5168 2.25525L21.0897 2.03701C21.0897 2.03701 21.0533 1.95517 20.9806 1.79148ZM21.0897 2.03701L20.5168 2.25525L55.7902 94.299L56.3359 94.0808L21.0897 2.03701ZM56.3631 94.0808L55.8175 94.299C55.8175 94.299 55.8448 94.3809 55.8994 94.5445L56.4723 94.3536C56.3995 94.1717 56.3631 94.0808 56.3631 94.0808ZM20.4622 2.00973L19.8894 2.22797C19.9621 2.39165 19.9985 2.47349 19.9985 2.47349L20.5441 2.25525C20.5441 2.25525 20.5168 2.17341 20.4622 2.00973ZM20.5441 2.25525L19.9985 2.47349L55.2719 94.5173L55.8175 94.299L20.5441 2.25525ZM55.8175 94.299L55.2446 94.5173C55.2446 94.5173 55.281 94.5991 55.3538 94.7628L55.8994 94.5445C55.8448 94.3809 55.8175 94.299 55.8175 94.299ZM19.8894 2.22797L19.3438 2.44621C19.3983 2.60989 19.4256 2.69174 19.4256 2.69174L19.9985 2.47349C19.9985 2.47349 19.9621 2.39165 19.8894 2.22797ZM19.9985 2.47349L19.4256 2.69174L54.699 94.7355L55.2446 94.5173L19.9985 2.47349ZM55.2719 94.5173L54.7263 94.7355C54.7263 94.7355 54.7536 94.8173 54.8082 94.981L55.381 94.7628C55.3083 94.5991 55.2719 94.5173 55.2719 94.5173ZM19.371 2.44621C19.371 2.44621 19.3619 2.44621 19.3438 2.44621C19.4165 2.60989 19.4529 2.69174 19.4529 2.69174C19.4529 2.69174 19.4256 2.60989 19.371 2.44621ZM19.4529 2.69174L54.699 94.7355C54.7172 94.7355 54.7263 94.7355 54.7263 94.7355L19.4529 2.69174Z",
    fill: "url(#paint2_linear_15268_36948)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_15268_36948",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 93,
    width: 4,
    height: 3
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9347 93.8789L57.0301 94.1272C57.2675 94.7437 56.9592 95.4366 56.3427 95.6712C55.7261 95.9086 55.0359 95.6003 54.7986 94.9838L54.7031 94.7328L56.9347 93.8789Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_15268_36948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9281 93.8906L57.0099 94.1361C57.0099 94.1361 57.019 94.1361 57.0372 94.1361L56.9281 93.8906ZM56.9008 93.8633L56.7644 93.9178L56.8462 94.1906L57.0099 94.1361L56.9008 93.8633ZM56.9826 94.1088L56.8462 94.1634L58.5649 98.6101L58.7013 98.5555L56.9826 94.1088ZM56.7371 93.9178L56.6007 93.9724L56.7098 94.2179L56.8462 94.1634L56.7371 93.9178ZM56.819 94.1634L56.6826 94.2179L58.4012 98.6919L58.5376 98.6373L56.819 94.1634ZM56.5734 93.9724L56.3006 94.0815L56.4097 94.327L56.6826 94.2179L56.5734 93.9724ZM56.6553 94.2179L56.3825 94.327L58.1011 98.801L58.3739 98.6919L56.6553 94.2179ZM56.2733 94.0815L55.7277 94.2725L55.8096 94.518L56.3825 94.327L56.2733 94.0815ZM56.3552 94.327L55.8096 94.5453L57.5282 98.992L58.0739 98.7737L56.3552 94.327ZM55.7005 94.2998L55.1549 94.518L55.2367 94.7635L55.8096 94.5453L55.7005 94.2998ZM55.7823 94.5453L55.2367 94.7635L56.9554 99.2375L57.501 99.0193L55.7823 94.5453ZM55.1276 94.518L54.582 94.709L54.6638 94.9818L55.2367 94.7635L55.1276 94.518ZM55.2094 94.7635L54.6638 94.9818L56.3552 99.4285L56.9281 99.2375L55.2094 94.7635ZM54.5547 94.709L54.6365 94.9818C54.6365 94.9636 54.6365 94.9545 54.6365 94.9545L54.5547 94.709ZM54.6638 94.9818L56.3552 99.4285C56.3734 99.4285 56.3825 99.4285 56.3825 99.4285L54.6638 94.9818Z",
    fill: "url(#paint3_linear_15268_36948)"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3035 80.9327C32.3035 80.9327 33.0128 76.1859 31.0487 74.0308C30.4485 73.4033 29.6028 73.0487 29.0299 73.3215C27.4477 74.0853 29.6028 79.4596 32.3035 80.9327Z",
    fill: "url(#paint4_linear_15268_36948)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2923 80.9312C32.2923 80.9312 30.4373 82.0497 26.4543 82.1316C24.6266 82.1861 23.6172 81.4496 23.6172 80.8494C23.6172 78.6943 29.8917 79.9219 32.2923 80.9312Z",
    fill: "url(#paint5_linear_15268_36948)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9974 77.6866C25.9974 77.6866 27.5251 73.1581 25.9428 70.6756C25.479 69.939 24.6879 69.4479 24.0877 69.6116C22.3964 70.1299 23.5967 75.777 25.9974 77.6866Z",
    fill: "url(#paint6_linear_15268_36948)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9932 77.6856C25.9932 77.6856 23.9744 78.4767 20.0188 77.8766C18.2183 77.6038 17.3453 76.7308 17.4544 76.1034C17.8363 74.0028 23.8107 76.267 25.9932 77.6856Z",
    fill: "url(#paint7_linear_15268_36948)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4886 73.048C20.4886 73.048 23.4076 69.2288 22.6983 66.3917C22.5074 65.546 21.9072 64.8094 21.307 64.7821C19.5338 64.7003 18.8245 70.4564 20.4886 73.048Z",
    fill: "url(#paint8_linear_15268_36948)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4869 73.0469C20.4869 73.0469 18.3317 73.1287 14.7853 71.3009C13.1758 70.4552 12.6302 69.3367 12.9302 68.7911C13.9396 66.9088 18.8774 71.0008 20.4869 73.0469Z",
    fill: "url(#paint9_linear_15268_36948)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16.334 67.047C16.334 67.047 19.8532 63.7733 19.6622 60.8543C19.6077 59.9814 19.1439 59.1903 18.5437 59.0539C16.7978 58.6719 15.161 64.2371 16.334 67.047Z",
    fill: "url(#paint10_linear_15268_36948)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3424 67.0459C16.3424 67.0459 14.2145 66.7731 11.0227 64.3724C9.57687 63.254 9.24951 62.0536 9.63144 61.5899C10.9409 59.8985 15.1148 64.7544 16.3424 67.0459Z",
    fill: "url(#paint11_linear_15268_36948)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7204 60.2531C13.7204 60.2531 17.676 57.5796 17.9216 54.6606C18.0034 53.7876 17.676 52.9147 17.1032 52.6964C15.4391 52.0417 12.9566 57.3068 13.7204 60.2531Z",
    fill: "url(#paint12_linear_15268_36948)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7186 60.2535C13.7186 60.2535 11.6453 59.6534 8.86273 56.8162C7.58055 55.5068 7.44415 54.2519 7.88064 53.8427C9.43561 52.3968 12.8457 57.8256 13.7186 60.2535Z",
    fill: "url(#paint13_linear_15268_36948)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9766 52.5039C12.9766 52.5039 17.5869 51.1672 18.7327 48.4664C19.0601 47.6753 19.0055 46.7478 18.5417 46.3659C17.1504 45.2201 13.1675 49.4485 12.9766 52.5039Z",
    fill: "url(#paint14_linear_15268_36948)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9831 52.5054C12.9831 52.5054 11.2098 51.3051 9.43661 47.7314C8.64548 46.0946 8.86373 44.867 9.43661 44.5942C11.3735 43.6939 12.9285 49.9138 12.9831 52.5054Z",
    fill: "url(#paint15_linear_15268_36948)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2422 45.0298C14.2422 45.0298 19.0435 44.757 20.7622 42.3837C21.2532 41.6744 21.4169 40.7741 21.035 40.2831C19.9438 38.8645 15.1424 42.0836 14.2422 45.0298Z",
    fill: "url(#paint16_linear_15268_36948)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2422 45.0307C14.2422 45.0307 12.7691 43.4485 11.8688 39.5474C11.4596 37.8015 11.9507 36.6557 12.5781 36.5193C14.6514 36.0828 14.7606 42.4937 14.2422 45.0307Z",
    fill: "url(#paint17_linear_15268_36948)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2344 38.3458C17.2344 38.3458 21.872 39.5734 24.2181 37.8548C24.9274 37.3364 25.3639 36.518 25.1457 35.9179C24.5455 34.2538 18.9803 35.836 17.2344 38.3458Z",
    fill: "url(#paint18_linear_15268_36948)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2326 38.3472C17.2326 38.3472 16.3051 36.4103 16.6325 32.4274C16.7962 30.6269 17.6146 29.672 18.242 29.7539C20.3699 29.9721 18.4875 36.1102 17.2326 38.3472Z",
    fill: "url(#paint19_linear_15268_36948)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5234 32.9464C21.5234 32.9464 25.37 34.9651 27.7979 33.9285C28.5345 33.6011 29.0801 32.9736 28.9982 32.428C28.8073 30.8185 23.5967 31.0913 21.5234 32.9464Z",
    fill: "url(#paint20_linear_15268_36948)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4668 33.0274C21.4668 33.0274 21.0576 30.8995 22.367 27.1348C22.9672 25.4161 24.0039 24.7069 24.5767 24.9251C26.5682 25.6617 23.2673 31.145 21.4668 33.0274Z",
    fill: "url(#paint21_linear_15268_36948)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6979 83.0329C26.7023 83.0329 12.8984 69.8019 12.8984 53.4883C12.8984 41.8941 19.8549 31.855 29.9759 27.0264",
    stroke: "url(#paint22_linear_15268_36948)",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5625 29.5912C25.5625 29.5912 29.7364 29.3184 31.8643 27.3269C32.4371 26.7813 32.7645 25.6901 32.3826 25.1991C31.2641 23.8078 26.4082 26.6722 25.5625 29.5912Z",
    fill: "url(#paint23_linear_15268_36948)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8982 80.9327C81.8982 80.9327 81.1889 76.1859 83.1531 74.0308C83.7532 73.4033 84.5989 73.0487 85.1718 73.3215C86.7541 74.0853 84.5989 79.4596 81.8982 80.9327Z",
    fill: "url(#paint24_linear_15268_36948)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8984 80.9312C81.8984 80.9312 83.7535 82.0497 87.7364 82.1316C89.5642 82.1861 90.5736 81.4496 90.5736 80.8494C90.5736 78.6943 84.2991 79.9219 81.8984 80.9312Z",
    fill: "url(#paint25_linear_15268_36948)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1943 77.6866C88.1943 77.6866 86.6666 73.1581 88.2489 70.6756C88.7127 69.939 89.5038 69.4479 90.104 69.6116C91.7953 70.1299 90.595 75.777 88.1943 77.6866Z",
    fill: "url(#paint26_linear_15268_36948)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1953 77.6856C88.1953 77.6856 90.2141 78.4767 94.1697 77.8766C95.9702 77.6038 96.8432 76.7308 96.734 76.1034C96.3521 74.0028 90.3777 76.267 88.1953 77.6856Z",
    fill: "url(#paint27_linear_15268_36948)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7036 73.048C93.7036 73.048 90.7846 69.2288 91.4939 66.3917C91.6849 65.546 92.285 64.8094 92.8852 64.7821C94.6584 64.7003 95.3677 70.4564 93.7036 73.048Z",
    fill: "url(#paint28_linear_15268_36948)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7031 73.0469C93.7031 73.0469 95.8583 73.1287 99.4047 71.3009C101.014 70.4552 101.56 69.3367 101.26 68.7911C100.25 66.9088 95.3127 71.0008 93.7031 73.0469Z",
    fill: "url(#paint29_linear_15268_36948)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8513 67.047C97.8513 67.047 94.3322 63.7733 94.5231 60.8543C94.5777 59.9814 95.0414 59.1903 95.6416 59.0539C97.3876 58.6719 99.0244 64.2371 97.8513 67.047Z",
    fill: "url(#paint30_linear_15268_36948)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8594 67.0459C97.8594 67.0459 99.9872 66.7731 103.179 64.3724C104.625 63.254 104.952 62.0536 104.57 61.5899C103.261 59.8985 99.087 64.7544 97.8594 67.0459Z",
    fill: "url(#paint31_linear_15268_36948)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M100.471 60.2531C100.471 60.2531 96.5158 57.5796 96.2703 54.6606C96.1884 53.7876 96.5158 52.9147 97.0887 52.6964C98.7528 52.0417 101.235 57.3068 100.471 60.2531Z",
    fill: "url(#paint32_linear_15268_36948)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M100.469 60.2535C100.469 60.2535 102.542 59.6534 105.325 56.8162C106.607 55.5068 106.743 54.2519 106.307 53.8427C104.752 52.3968 101.342 57.8256 100.469 60.2535Z",
    fill: "url(#paint33_linear_15268_36948)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M101.207 52.5039C101.207 52.5039 96.5963 51.1672 95.4505 48.4664C95.1232 47.6753 95.1777 46.7478 95.6415 46.3659C97.0328 45.2201 101.016 49.4485 101.207 52.5039Z",
    fill: "url(#paint34_linear_15268_36948)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M101.211 52.5054C101.211 52.5054 102.984 51.3051 104.757 47.7314C105.549 46.0946 105.33 44.867 104.757 44.5942C102.82 43.6939 101.265 49.9138 101.211 52.5054Z",
    fill: "url(#paint35_linear_15268_36948)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9569 45.0298C99.9569 45.0298 95.1556 44.757 93.4369 42.3837C92.9459 41.6744 92.7822 40.7741 93.1641 40.2831C94.2554 38.8645 99.0567 42.0836 99.9569 45.0298Z",
    fill: "url(#paint36_linear_15268_36948)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9566 45.0307C99.9566 45.0307 101.43 43.4485 102.33 39.5474C102.739 37.8015 102.248 36.6557 101.621 36.5193C99.5474 36.0828 99.4383 42.4937 99.9566 45.0307Z",
    fill: "url(#paint37_linear_15268_36948)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M96.96 38.3458C96.96 38.3458 92.3223 39.5734 89.9762 37.8548C89.2669 37.3364 88.8304 36.518 89.0487 35.9179C89.6488 34.2538 95.214 35.836 96.96 38.3458Z",
    fill: "url(#paint38_linear_15268_36948)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9569 38.3472C96.9569 38.3472 97.8844 36.4103 97.5571 32.4274C97.3934 30.6269 96.575 29.672 95.9475 29.7539C93.8197 29.9721 95.702 36.1102 96.9569 38.3472Z",
    fill: "url(#paint39_linear_15268_36948)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6782 32.9464C92.6782 32.9464 88.8317 34.9651 86.4038 33.9285C85.6672 33.6011 85.1216 32.9736 85.2034 32.428C85.3944 30.8185 90.6049 31.0913 92.6782 32.9464Z",
    fill: "url(#paint40_linear_15268_36948)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7204 33.0274C92.7204 33.0274 93.1296 30.8995 91.8201 27.1348C91.22 25.4161 90.1833 24.7069 89.6104 24.9251C87.619 25.6617 90.9199 31.145 92.7204 33.0274Z",
    fill: "url(#paint41_linear_15268_36948)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4844 83.0329C87.48 83.0329 101.284 69.8019 101.284 53.4883C101.284 41.8941 94.3274 31.855 84.2064 27.0264",
    stroke: "url(#paint42_linear_15268_36948)",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6333 29.5912C88.6333 29.5912 84.4594 29.3184 82.3315 27.3269C81.7586 26.7813 81.4313 25.6901 81.8132 25.1991C82.9317 23.8078 87.7876 26.6722 88.6333 29.5912Z",
    fill: "url(#paint43_linear_15268_36948)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.57,
    d: "M104.397 122.727C104.397 123.682 83.2277 124.446 57.0931 124.446C30.9586 124.446 9.78906 123.682 9.78906 122.727C9.78906 121.773 30.9586 121.009 57.0931 121.009C83.2277 121.009 104.397 121.773 104.397 122.727Z",
    fill: "url(#paint44_radial_15268_36948)"
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2558 122.724H10.4453V100.954H48.2558V122.724Z",
    fill: "url(#paint45_linear_15268_36948)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2558 122.722H10.4453V115.793L48.2558 105.809V122.722Z",
    fill: "url(#paint46_linear_15268_36948)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3173 98.4434H29.3506H18.3839L10.4453 100.953H29.3506H48.2558L40.3173 98.4434Z",
    fill: "url(#paint47_linear_15268_36948)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9684 104.338C13.9684 104.829 13.5592 105.265 13.0682 105.265C12.5498 105.265 12.1406 104.829 12.1406 104.338C12.1406 103.819 12.5498 103.41 13.0682 103.41C13.5592 103.41 13.9684 103.819 13.9684 104.338Z",
    fill: "url(#paint48_linear_15268_36948)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M46.57 104.338C46.57 104.829 46.1608 105.265 45.6424 105.265C45.1514 105.265 44.7422 104.829 44.7422 104.338C44.7422 103.819 45.1514 103.41 45.6424 103.41C46.1608 103.41 46.57 103.819 46.57 104.338Z",
    fill: "url(#paint49_linear_15268_36948)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9684 119.34C13.9684 119.858 13.5592 120.267 13.0682 120.267C12.5498 120.267 12.1406 119.858 12.1406 119.34C12.1406 118.821 12.5498 118.412 13.0682 118.412C13.5592 118.412 13.9684 118.821 13.9684 119.34Z",
    fill: "url(#paint50_linear_15268_36948)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M46.57 119.34C46.57 119.858 46.1608 120.267 45.6424 120.267C45.1514 120.267 44.7422 119.858 44.7422 119.34C44.7422 118.821 45.1514 118.412 45.6424 118.412C46.1608 118.412 46.57 118.821 46.57 119.34Z",
    fill: "url(#paint51_linear_15268_36948)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M37.786 111.623C37.786 116.178 34.1031 119.861 29.5473 119.861C25.0188 119.861 21.3359 116.178 21.3359 111.623C21.3359 107.094 25.0188 103.411 29.5473 103.411C34.1031 103.411 37.786 107.094 37.786 111.623Z",
    fill: "url(#paint52_linear_15268_36948)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M37.261 111.623C37.261 115.906 33.8236 119.343 29.5406 119.343C25.2849 119.343 21.8203 115.906 21.8203 111.623C21.8203 107.367 25.2849 103.902 29.5406 103.902C33.8236 103.902 37.261 107.367 37.261 111.623Z",
    fill: "url(#paint53_linear_15268_36948)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8528 111.622C36.8528 115.659 33.5791 118.933 29.5417 118.933C25.5314 118.933 22.2578 115.659 22.2578 111.622C22.2578 107.612 25.5314 104.338 29.5417 104.338C33.5791 104.338 36.8528 107.612 36.8528 111.622Z",
    fill: "url(#paint54_linear_15268_36948)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3655 109.903C30.3655 109.603 30.1472 109.439 29.7653 109.439C29.1106 109.439 28.2103 109.875 27.3647 110.585L26.2734 108.484C27.5283 107.611 28.8378 107.093 30.2291 107.093C32.0569 107.093 33.4209 108.048 33.4209 109.493C33.4209 110.503 32.6843 111.485 31.7022 112.467L30.3382 113.831H33.5573V116.068H26.6281V114.213L29.7108 111.021C30.0654 110.666 30.3655 110.203 30.3655 109.903Z",
    fill: "url(#paint55_linear_15268_36948)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M103.747 122.729H72.2656V104.588H103.747V122.729Z",
    fill: "url(#paint56_linear_15268_36948)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M103.747 122.729H72.2656V116.973L103.747 108.625V122.729Z",
    fill: "url(#paint57_linear_15268_36948)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1453 102.514H88.0064H78.8675L72.2656 104.587H88.0064H103.747L97.1453 102.514Z",
    fill: "url(#paint58_linear_15268_36948)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2152 107.421C75.2152 107.83 74.8606 108.185 74.4514 108.185C74.0149 108.185 73.6875 107.83 73.6875 107.421C73.6875 106.985 74.0149 106.657 74.4514 106.657C74.8606 106.657 75.2152 106.985 75.2152 107.421Z",
    fill: "url(#paint59_linear_15268_36948)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M102.325 107.421C102.325 107.83 101.997 108.185 101.561 108.185C101.152 108.185 100.797 107.83 100.797 107.421C100.797 106.985 101.152 106.657 101.561 106.657C101.997 106.657 102.325 106.985 102.325 107.421Z",
    fill: "url(#paint60_linear_15268_36948)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2152 119.917C75.2152 120.326 74.8606 120.681 74.4514 120.681C74.0149 120.681 73.6875 120.326 73.6875 119.917C73.6875 119.481 74.0149 119.153 74.4514 119.153C74.8606 119.153 75.2152 119.481 75.2152 119.917Z",
    fill: "url(#paint61_linear_15268_36948)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M102.325 119.917C102.325 120.326 101.997 120.681 101.561 120.681C101.152 120.681 100.797 120.326 100.797 119.917C100.797 119.481 101.152 119.153 101.561 119.153C101.997 119.153 102.325 119.481 102.325 119.917Z",
    fill: "url(#paint62_linear_15268_36948)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M95.015 113.477C95.015 117.269 91.9596 120.325 88.1677 120.325C84.403 120.325 81.3203 117.269 81.3203 113.477C81.3203 109.713 84.403 106.657 88.1677 106.657C91.9596 106.657 95.015 109.713 95.015 113.477Z",
    fill: "url(#paint63_linear_15268_36948)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6107 113.477C94.6107 117.051 91.719 119.915 88.1725 119.915C84.6261 119.915 81.7344 117.051 81.7344 113.477C81.7344 109.931 84.6261 107.066 88.1725 107.066C91.719 107.066 94.6107 109.931 94.6107 113.477Z",
    fill: "url(#paint64_linear_15268_36948)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M94.253 113.478C94.253 116.834 91.5249 119.562 88.1694 119.562C84.814 119.562 82.0859 116.834 82.0859 113.478C82.0859 110.123 84.814 107.422 88.1694 107.422C91.5249 107.422 94.253 110.123 94.253 113.478Z",
    fill: "url(#paint65_linear_15268_36948)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0616 115.033C91.0616 116.315 89.9977 117.215 88.3608 117.215C87.3515 117.215 86.2875 116.86 85.6328 116.342L86.4785 114.705C87.0059 115.305 87.5788 115.615 88.1972 115.633C88.7064 115.633 88.961 115.442 88.961 115.06C88.961 114.678 88.7064 114.487 88.1972 114.487H86.9695V113.369L88.1972 112.168H85.9875V110.613H90.7615V111.814L89.2338 113.15L89.5339 113.232C90.4341 113.423 91.0616 114.078 91.0616 115.033Z",
    fill: "url(#paint66_linear_15268_36948)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0883 122.726H34.0938V96.21H80.0883V122.726Z",
    fill: "url(#paint67_linear_15268_36948)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0883 122.726H34.0938V114.296L80.0883 102.129V122.726Z",
    fill: "url(#paint68_linear_15268_36948)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4584 93.1816H57.0911H43.7237L34.0938 96.2097H57.0911H80.0883L70.4584 93.1816Z",
    fill: "url(#paint69_linear_15268_36948)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3854 100.329C38.3854 100.957 37.8671 101.448 37.2669 101.448C36.6395 101.448 36.1484 100.957 36.1484 100.329C36.1484 99.702 36.6395 99.2109 37.2669 99.2109C37.8671 99.2109 38.3854 99.702 38.3854 100.329Z",
    fill: "url(#paint70_linear_15268_36948)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0495 100.329C78.0495 100.957 77.5584 101.448 76.931 101.448C76.3308 101.448 75.8125 100.957 75.8125 100.329C75.8125 99.702 76.3308 99.2109 76.931 99.2109C77.5584 99.2109 78.0495 99.702 78.0495 100.329Z",
    fill: "url(#paint71_linear_15268_36948)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3854 118.607C38.3854 119.234 37.8671 119.725 37.2669 119.725C36.6395 119.725 36.1484 119.234 36.1484 118.607C36.1484 117.979 36.6395 117.488 37.2669 117.488C37.8671 117.488 38.3854 117.979 38.3854 118.607Z",
    fill: "url(#paint72_linear_15268_36948)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0495 118.607C78.0495 119.234 77.5584 119.725 76.931 119.725C76.3308 119.725 75.8125 119.234 75.8125 118.607C75.8125 117.979 76.3308 117.488 76.931 117.488C77.5584 117.488 78.0495 117.979 78.0495 118.607Z",
    fill: "url(#paint73_linear_15268_36948)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3597 109.223C67.3597 114.733 62.8857 119.235 57.3478 119.235C51.8372 119.235 47.3359 114.733 47.3359 109.223C47.3359 103.685 51.8372 99.2109 57.3478 99.2109C62.8857 99.2109 67.3597 103.685 67.3597 109.223Z",
    fill: "url(#paint74_linear_15268_36948)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7609 109.222C66.7609 114.406 62.5325 118.607 57.3492 118.607C52.1659 118.607 47.9375 114.406 47.9375 109.222C47.9375 104.039 52.1659 99.8105 57.3492 99.8105C62.5325 99.8105 66.7609 104.039 66.7609 109.222Z",
    fill: "url(#paint75_linear_15268_36948)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2321 109.222C66.2321 114.132 62.2491 118.115 57.3387 118.115C52.4282 118.115 48.4453 114.132 48.4453 109.222C48.4453 104.311 52.4282 100.328 57.3387 100.328C62.2491 100.328 66.2321 104.311 66.2321 109.222Z",
    fill: "url(#paint76_linear_15268_36948)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6705 104.23V115.415H56.9603V107.149H55.0234V104.23H60.6705Z",
    fill: "url(#paint77_linear_15268_36948)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6867 90.5072C67.7864 90.8891 66.2587 90.8891 66.2587 90.8891C65.7131 87.0153 63.5852 79.4859 61.9484 74.0026C61.321 71.902 60.7754 70.1015 60.3935 68.9284C60.1207 68.0009 59.9297 67.4553 59.9297 67.4553L64.1309 65.873C64.1309 65.873 64.8674 67.5371 65.3312 68.9284C65.4949 69.4468 65.604 69.9105 65.6586 70.2652C65.6858 70.5107 65.8222 71.4655 66.0132 72.8295C66.8316 78.3129 68.6867 90.5072 68.6867 90.5072Z",
    fill: "#FAA38C"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M65.3312 68.9284C63.1215 68.2737 60.7208 68.8466 60.3935 68.9284C60.1207 68.0009 59.9297 67.4553 59.9297 67.4553L64.1309 65.873C64.1309 65.873 64.8674 67.5371 65.3312 68.9284Z",
    fill: "#FC8E6B"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6836 90.5077C67.7833 90.8896 66.2556 90.8896 66.2556 90.8896C65.71 87.0158 63.5821 79.4865 61.9453 74.0031L66.0101 72.8301C66.8285 78.3134 68.6836 90.5077 68.6836 90.5077Z",
    fill: "#F3E2DA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6131 95.5539H67.0292C65.9652 95.5539 65.3105 95.5539 65.3105 95.5539C65.2923 95.3538 65.2923 95.181 65.3105 95.0355C65.3378 94.3263 65.5833 93.9443 65.7197 93.0168C65.8561 91.871 66.1835 90.3161 66.1835 90.3161C66.7018 90.3161 67.1656 90.2342 67.5475 90.1524C68.2568 89.9614 68.6933 89.7432 68.6933 89.7432C69.2662 90.9708 69.9755 91.38 69.9755 91.38L71.9669 93.2623C73.9584 93.5078 74.4767 94.4354 74.6131 95.0355C74.6677 95.3356 74.6131 95.5539 74.6131 95.5539Z",
    fill: "#2F2065"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6131 95.5521H67.0292C65.9652 95.5521 65.3105 95.5521 65.3105 95.5521C65.2923 95.352 65.2923 95.1792 65.3105 95.0337C66.2926 95.0337 67.5748 94.8428 67.5748 94.8428C67.5748 94.8428 67.6839 95.0337 68.9934 95.0337C70.2755 95.0337 74.6131 95.0337 74.6131 95.0337C74.6677 95.3338 74.6131 95.5521 74.6131 95.5521Z",
    fill: "#231951"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9663 93.2623C71.9663 93.2623 70.8751 93.6988 70.3568 93.4533C69.8384 93.2078 69.5111 92.6894 68.8836 92.0074C68.2289 91.3254 67.5469 90.1524 67.5469 90.1524C68.2562 89.9614 68.6927 89.7432 68.6927 89.7432C69.2655 90.9708 69.9748 91.38 69.9748 91.38L71.9663 93.2623Z",
    fill: "#32266B"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0284 67.4553C52.0284 67.4553 51.9193 68.0555 51.7556 69.0921C51.5374 70.2379 51.2646 71.9566 50.9372 73.9207C50.0097 79.4041 48.7548 86.988 48.1819 90.8891C48.1819 90.8891 46.6542 90.8891 45.7812 90.5072C45.7812 90.5072 46.0268 77.9037 46.2177 72.5567C46.2177 71.902 46.245 71.3564 46.2723 70.9472C46.2723 70.5925 46.2996 70.3743 46.2996 70.2652C46.4633 68.983 47.8273 65.873 47.8273 65.873L52.0284 67.4553Z",
    fill: "#FAA38C"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M52.0218 67.4553C52.0218 67.4553 51.9126 68.0555 51.749 69.0921C48.4753 69.4195 46.9204 70.3743 46.2656 70.9472C46.2656 70.5925 46.2929 70.3743 46.2929 70.2652C46.4566 68.983 47.8206 65.873 47.8206 65.873L52.0218 67.4553Z",
    fill: "#FC8E6B"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9372 73.9216C50.0097 79.405 48.7548 86.9889 48.1819 90.89C48.1819 90.89 46.6542 90.89 45.7812 90.5081C45.7812 90.5081 46.0268 77.9046 46.2177 72.5576L50.9372 73.9216Z",
    fill: "#F3E2DA"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8271 95.5539H47.4111C48.5023 95.5539 49.1297 95.5539 49.1297 95.5539C49.1479 95.3538 49.157 95.181 49.157 95.0355C49.1297 94.3263 48.8569 93.9443 48.7478 93.0168C48.5841 91.871 48.2568 90.3161 48.2568 90.3161C47.7384 90.3161 47.2747 90.2342 46.8927 90.1524C46.1834 89.9614 45.7742 89.7432 45.7742 89.7432C45.1741 90.9708 44.4921 91.38 44.4921 91.38L42.5006 93.2623C40.4819 93.5078 39.9635 94.4354 39.8544 95.0355C39.7999 95.3356 39.8271 95.5539 39.8271 95.5539Z",
    fill: "#2F2065"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8271 95.5521H47.4111C48.5023 95.5521 49.1297 95.5521 49.1297 95.5521C49.1479 95.352 49.157 95.1792 49.157 95.0337C48.1476 95.0337 46.8655 94.8428 46.8655 94.8428C46.8655 94.8428 46.7563 95.0337 45.4742 95.0337C44.192 95.0337 39.8544 95.0337 39.8544 95.0337C39.7999 95.3338 39.8271 95.5521 39.8271 95.5521Z",
    fill: "#231951"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 93.2623C42.5 93.2623 43.5912 93.6988 44.1095 93.4533C44.6279 93.2078 44.9279 92.6894 45.5827 92.0074C46.2101 91.3254 46.8921 90.1524 46.8921 90.1524C46.1828 89.9614 45.7736 89.7432 45.7736 89.7432C45.1735 90.9708 44.4915 91.38 44.4915 91.38L42.5 93.2623Z",
    fill: "#32266B"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1864 27.6267C66.7499 27.9814 66.4498 28.1996 66.4498 28.1996L63.3672 25.6898L68.5232 20.9158C68.5232 20.9158 67.6229 20.1246 66.7499 17.2056C65.9315 14.5049 64.813 13.1136 64.6766 12.9499C64.6766 12.9317 64.6766 12.9226 64.6766 12.9226C64.6584 12.9226 64.6584 12.9226 64.6766 12.9226C64.6766 12.9226 63.0671 12.5134 62.3578 11.6132C61.6212 10.7129 61.9486 8.09402 62.3851 8.12131C62.8216 8.17587 65.5223 8.55779 66.1498 8.88515C66.7772 9.21252 67.05 12.9772 67.05 12.9772C67.05 12.9772 72.1514 19.6882 72.8607 21.325C72.8607 21.3432 72.8698 21.3523 72.888 21.3523C73.4063 22.6617 69.0142 26.2354 67.1864 27.6267Z",
    fill: "url(#paint78_linear_15268_36948)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.19
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1937 27.626C66.7845 26.1256 66.4844 24.8434 66.4844 24.8434C66.4844 24.8434 70.9583 23.1793 72.8952 21.3516C73.4136 22.661 69.0214 26.2347 67.1937 27.626Z",
    fill: "#FC8E6B"
  }))), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4048 25.0352V32.0735H53.4219V25.0352H57.4048Z",
    fill: "url(#paint79_linear_15268_36948)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.19
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4048 25.0352V26.5901C56.9683 26.9993 55.9317 27.5177 53.4219 27.6813V25.0352H57.4048Z",
    fill: "#FC8E6B"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2278 20.1794C51.2278 20.1794 50.0002 19.8793 50.082 20.9705C50.1912 22.3618 51.8825 22.6346 51.8825 22.6346L51.2278 20.1794Z",
    fill: "#FAA38C"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1235 20.1794C60.1235 20.1794 61.3511 19.8793 61.2692 20.9705C61.1601 22.3618 59.4688 22.6346 59.4688 22.6346L60.1235 20.1794Z",
    fill: "url(#paint80_linear_15268_36948)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6553 25.0619C57.8096 26.1259 56.8548 26.5351 56.2546 26.6715C55.8999 26.7533 55.6817 26.7533 55.6817 26.7533C55.6817 26.7533 54.0449 26.7533 52.7081 25.0619C51.3714 23.3706 50.9076 19.2239 51.426 17.9691C51.9716 16.7142 55.6817 15.1592 55.6817 15.1592C55.6817 15.1592 58.1915 15.3501 59.4737 17.1234C59.6555 17.378 59.8101 17.6599 59.9374 17.9691C60.4285 19.2239 59.992 23.3706 58.6553 25.0619Z",
    fill: "url(#paint81_linear_15268_36948)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.19
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6507 25.0626C57.805 26.1265 56.8502 26.5357 56.25 26.6721C60.6421 23.0984 59.0599 17.124 59.0599 17.124H59.4691C59.651 17.3786 59.8055 17.6605 59.9328 17.9697C60.4239 19.2246 59.9874 23.3712 58.6507 25.0626Z",
    fill: "#FC8E6B"
  }))), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1316 16.6056C58.1316 16.6056 53.4121 15.5962 51.8299 18.2424C51.8299 18.2424 51.8026 19.6883 51.2297 20.1793C51.2297 20.1793 50.7932 18.788 51.0387 18.0788C51.0387 18.0788 50.8478 18.1879 50.4386 18.3516C50.4386 18.3516 50.1931 16.6056 51.5844 14.887H50.6841C50.6841 14.887 52.0208 13.1683 54.3669 13.0319C54.3669 13.0319 53.9032 12.6227 54.2033 12.0498C54.2033 12.0498 55.1035 12.9773 56.9859 12.9773C58.8682 12.9773 58.9773 14.0685 58.9773 14.0685C58.9773 14.0685 62.0327 13.5775 60.1231 20.1793C60.1231 20.1793 59.4684 19.7429 59.5775 18.4607C59.5775 18.4607 59.4411 18.2697 58.1316 16.6056Z",
    fill: "url(#paint82_linear_15268_36948)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M64.931 67.2084C62.4212 68.5724 59.5022 68.436 59.5022 68.436L55.1101 55.1778L54.7009 55.205C54.3462 56.2417 52.0274 68.436 52.0274 68.436L46.4895 67.8358C46.4895 67.8358 46.4077 61.4249 46.4895 56.078C46.4895 54.7958 46.5986 53.6773 46.735 52.7225C47.1988 49.8035 48.0718 48.4668 48.0718 48.4668L61.6301 49.5853C64.0035 54.4139 64.931 67.2084 64.931 67.2084Z",
    fill: "url(#paint83_linear_15268_36948)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.13,
    d: "M61.6294 49.5853C61.6294 49.5853 59.0105 51.9314 52.7906 52.3133C50.3354 52.477 48.3166 52.6134 46.7344 52.7225C47.1981 49.8035 48.0711 48.4668 48.0711 48.4668L61.6294 49.5853Z",
    fill: "url(#paint84_linear_15268_36948)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.36,
    d: "M59.5045 68.4376L55.1123 55.1793L54.7031 55.2066L55.3851 52.5059L59.5045 68.4376Z",
    fill: "url(#paint85_linear_15268_36948)"
  }), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M67.676 27.5176C67.676 27.5176 67.0485 28.145 66.2847 28.9362C65.2753 30.0001 64.075 31.3641 63.9386 31.8279C63.7476 32.428 62.6564 41.2123 62.0562 46.1773C61.8107 48.1961 61.6198 49.5873 61.6198 49.5873C61.6198 49.5873 55.9727 52.2608 47.6522 49.3145C47.6522 49.3145 47.8432 47.6504 47.9796 45.3316C48.1433 42.3581 48.1978 38.3479 47.6249 35.4561C47.5522 35.0742 47.4704 34.7196 47.3794 34.3922L44.2422 34.174L44.7332 29.018C46.9429 28.7725 53.4357 27.9541 53.4357 27.9541C53.4357 27.9541 53.4357 30.0274 55.318 30.0274C57.0912 30.0274 57.3913 27.7358 57.3913 27.7358C57.3913 27.7358 60.7741 26.9992 62.8474 25.2806C64.9207 23.5619 65.4935 23.3164 65.4935 23.3164C65.4935 23.3164 65.9573 23.9711 66.4756 24.8441C66.9667 25.6625 67.485 26.6719 67.676 27.5176Z",
    fill: "url(#paint86_linear_15268_36948)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7332 29.0181L44.2422 34.1741L47.3794 34.3924C47.3794 34.3924 48.8526 32.2645 48.9617 28.418C47.3249 28.6635 45.6608 28.909 44.7332 29.0181Z",
    fill: "url(#paint87_linear_15268_36948)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6833 27.5176C67.2741 25.7716 65.5009 23.3164 65.5009 23.3164C65.5009 23.3164 64.928 23.5619 62.8547 25.2806C62.2545 25.7716 61.5452 26.2081 60.8359 26.5355C61.0815 27.4085 61.8999 29.7273 63.9459 31.8279C64.1914 31.0095 67.6833 27.5176 67.6833 27.5176Z",
    fill: "url(#paint88_linear_15268_36948)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M60.3655 39.3301C60.3655 39.3301 58.8923 45.1135 51.2266 47.2141C51.2266 47.2141 60.2836 47.3505 60.3655 39.3301Z",
    fill: "url(#paint89_linear_15268_36948)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M67.6812 27.5172C67.6812 27.5172 67.0538 28.1447 66.2899 28.9358C65.2806 29.9997 64.0802 31.3637 63.9438 31.8275C63.7529 32.4277 62.6617 41.2119 62.0615 46.177C61.816 48.1957 61.625 49.587 61.625 49.587C61.625 49.587 61.8705 34.6647 62.2252 30.9C62.5525 27.6536 65.6352 25.3894 66.4809 24.8438C66.9719 25.6622 67.4903 26.6715 67.6812 27.5172Z",
    fill: "url(#paint90_linear_15268_36948)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M47.9875 45.3323C48.1511 42.3587 48.2057 38.3485 47.6328 35.4568L50.77 34.5293C50.77 34.5293 50.8519 36.057 50.2244 37.421C49.8152 38.2667 50.3881 40.531 50.77 40.531C52.0795 40.531 52.2705 42.5224 52.2705 42.5224L47.9875 45.3323Z",
    fill: "url(#paint91_linear_15268_36948)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5812 29.0176C48.5812 29.0176 39.6606 29.7541 37.7782 31.0363C35.9232 32.3458 35.3776 33.6552 36.8234 34.2554C40.4244 35.7558 48.5812 32.8095 48.5812 32.8095V29.0176Z",
    fill: "#FC8E6B"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9091 23.0428C48.9091 23.0428 47.5451 23.1792 47.6815 21.4333C47.8451 19.6601 50.0003 18.5143 51.3916 19.0872C52.2918 19.4418 53.383 20.8604 52.892 23.3702C52.4828 25.3071 51.0915 27.9533 47.8451 31.2269L47.8724 28.7717C47.8724 28.7717 51.1733 26.8621 52.1827 22.9064C52.9193 20.042 50.4641 19.4691 49.4274 20.4512C48.5544 21.2696 49.8093 22.6064 48.9091 23.0428Z",
    fill: "url(#paint92_linear_15268_36948)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0175 26.8359C37.0175 26.8359 38.2178 26.1538 37.0721 24.8171C35.9263 23.4531 33.5256 23.7805 32.7072 25.0354C32.1616 25.8538 32.107 27.6543 33.9621 29.4002C35.408 30.7642 38.0541 32.101 42.61 32.8921L41.1914 30.9279C41.1914 30.9279 37.3994 31.2553 34.2622 28.6091C32.0252 26.6995 33.6893 24.8171 35.1079 25.0081C36.2809 25.1718 36.0354 26.9995 37.0175 26.8359Z",
    fill: "url(#paint93_linear_15268_36948)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8047 33.8743L48.1781 41.2945L50.0331 40.6944L45.9956 33.5742L45.8047 33.8743Z",
    fill: "url(#paint94_linear_15268_36948)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8039 33.8727L48.1773 41.293L46.3223 41.8659L45.4766 33.7363L45.8039 33.8727Z",
    fill: "url(#paint95_linear_15268_36948)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9422 41.4015L45.1766 43.5566L44.9857 42.9565C44.8493 42.5473 45.0675 42.0835 45.504 41.9471L50.7418 40.283C51.1783 40.1466 51.6148 40.3921 51.7512 40.8013L51.9422 41.4015Z",
    fill: "url(#paint96_linear_15268_36948)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7948 33.7083C47.1222 34.7723 46.9858 35.7816 46.4675 35.9453C45.9764 36.109 45.2671 35.3724 44.9398 34.2812C44.5851 33.2173 44.7215 32.2079 45.2398 32.0442C45.7582 31.8806 46.4402 32.6171 46.7948 33.7083Z",
    fill: "url(#paint97_linear_15268_36948)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8461 31.2282C47.4641 32.5649 46.8094 33.547 45.8 33.8744C41.4352 35.2657 35.4062 22.3894 35.4062 22.3894L37.2613 21.7892L41.5443 20.4525L45.8819 19.0612L47.1913 18.6247L47.6551 18.4883C47.6551 18.4883 49.1555 26.7815 47.8461 31.2282Z",
    fill: "url(#paint98_linear_15268_36948)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8461 31.2281C47.4641 32.5648 46.8094 33.5469 45.8 33.8742C41.4352 35.2655 35.4062 22.3892 35.4062 22.3892L37.2613 21.7891C37.916 23.2076 41.9262 31.2826 47.8461 31.2281Z",
    fill: "url(#paint99_linear_15268_36948)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M47.6833 29.0178C47.6833 29.0178 47.3287 21.8704 45.8828 19.0605L47.1923 18.624C47.4378 20.2063 48.1471 25.4168 47.6833 29.0178Z",
    fill: "url(#paint100_linear_15268_36948)"
  }), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6505 18.4886C47.7596 18.816 45.1135 19.9618 41.7307 21.0257C38.3207 22.1169 35.5108 22.7171 35.4017 22.3897C35.2925 22.0624 37.966 20.9166 41.3488 19.8526C44.7315 18.7614 47.5414 18.1613 47.6505 18.4886Z",
    fill: "url(#paint101_linear_15268_36948)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6041 35.4299C50.3313 36.1665 49.7584 37.0395 49.0219 37.285C48.3672 37.5032 46.3484 36.8212 44.4115 36.6302C42.611 36.412 36.0092 35.0207 35.9273 33.3566C35.9091 33.2293 35.9364 33.0929 36.0092 32.9474C36.4184 32.2108 37.646 31.7471 39.5011 31.7471C41.3834 31.7471 42.8838 33.684 46.3211 33.8204C46.3211 33.8204 47.7397 33.2475 48.3944 33.0292C49.0492 32.811 50.3313 33.7658 50.686 34.2569C50.8224 34.4478 50.7951 34.9116 50.6041 35.4299Z",
    fill: "url(#paint102_linear_15268_36948)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.19
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5987 35.4298C50.3259 36.1663 49.753 37.0393 49.0164 37.2848C48.3617 37.5031 46.343 36.821 44.4061 36.6301C42.6056 36.4118 36.0037 35.0205 35.9219 33.3564C37.586 35.5662 45.2245 36.2209 46.834 36.2482C48.4163 36.3027 50.5987 35.4298 50.5987 35.4298Z",
    fill: "#FC8E6B"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2109 37.011C55.2109 37.011 57.748 30.2182 58.2118 27.5175L59.6303 27.0537C59.6303 27.0537 56.9023 35.2105 55.6201 37.1747L55.2109 37.011Z",
    fill: "url(#paint103_linear_15268_36948)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5659 36.9288C54.5659 36.9288 52.5199 30.8453 52.0561 28.1445L50.9922 28.2809C50.9922 28.2809 52.9837 35.292 54.2658 37.2562L54.5659 36.9288Z",
    fill: "url(#paint104_linear_15268_36948)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1469 38.7023C57.1469 39.8208 56.2466 40.7211 55.1281 40.7211C54.0096 40.7211 53.1094 39.8208 53.1094 38.7023C53.1094 37.5838 54.0096 36.6836 55.1281 36.6836C56.2466 36.6836 57.1469 37.5838 57.1469 38.7023Z",
    fill: "url(#paint105_linear_15268_36948)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7425 38.7013C56.7425 39.6016 56.0332 40.3109 55.133 40.3109C54.2327 40.3109 53.5234 39.6016 53.5234 38.7013C53.5234 37.8011 54.2327 37.0918 55.133 37.0918C56.0332 37.0918 56.7425 37.8011 56.7425 38.7013Z",
    stroke: "#EDE5D8",
    strokeWidth: 0.6,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.19
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0367 20.4513L68.5184 20.9151C68.5184 20.9151 67.6182 20.1239 66.7452 17.2049C65.9268 14.5042 64.8083 13.1129 64.6719 12.9492C64.8356 13.1129 66.7997 15.1862 67.1271 16.8776C67.509 18.6508 69.0367 20.4513 69.0367 20.4513Z",
    fill: "#FC8E6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15268_36948",
    x1: -0.00300119,
    y1: 36.1109,
    x2: 11.6926,
    y2: 40.2065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9807"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF180C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15268_36948",
    x1: 19.8639,
    y1: -2.87698,
    x2: 17.6428,
    y2: -2.02595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#903920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15268_36948",
    x1: 21.5742,
    y1: 1.58552,
    x2: 19.3531,
    y2: 2.43653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#903920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15268_36948",
    x1: 56.9283,
    y1: 93.8794,
    x2: 54.7072,
    y2: 94.7304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#903920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15268_36948",
    x1: 25.0306,
    y1: 85.6435,
    x2: 21.0435,
    y2: 76.9605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15268_36948",
    x1: 33.7529,
    y1: 81.4659,
    x2: 23.1938,
    y2: 82.7857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15268_36948",
    x1: 15.2222,
    y1: 78.4957,
    x2: 14.7939,
    y2: 69.1577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_15268_36948",
    x1: 26.6757,
    y1: 79.2463,
    x2: 18.3647,
    y2: 77.4966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_15268_36948",
    x1: 9.20358,
    y1: 70.1809,
    x2: 11.8614,
    y2: 60.9244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_15268_36948",
    x1: 20.0594,
    y1: 76.0073,
    x2: 11.7041,
    y2: 70.9059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_15268_36948",
    x1: 7.34134,
    y1: 62.3398,
    x2: 11.8724,
    y2: 54.2024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_15268_36948",
    x1: 13.6823,
    y1: 70.2653,
    x2: 6.27432,
    y2: 62.8573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_15268_36948",
    x1: 6.39455,
    y1: 56.4889,
    x2: 12.7581,
    y2: 47.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_15268_36948",
    x1: 10.3768,
    y1: 64.859,
    x2: 4.82933,
    y2: 57.2863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_15268_36948",
    x1: 10.2267,
    y1: 48.3096,
    x2: 16.9115,
    y2: 42.2488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_15268_36948",
    x1: 5.31047,
    y1: 57.3477,
    x2: 1.80126,
    y2: 49.7153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_15268_36948",
    x1: 12.6667,
    y1: 41.5912,
    x2: 21.1343,
    y2: 37.2691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_15268_36948",
    x1: 0.75784,
    y1: 48.6776,
    x2: -0.809281,
    y2: 40.3197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_15268_36948",
    x1: 15.8633,
    y1: 36.3325,
    x2: 25.8042,
    y2: 33.9571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_15268_36948",
    x1: 3.17482,
    y1: 38.4953,
    x2: 3.86271,
    y2: 28.6065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_15268_36948",
    x1: 21.551,
    y1: 31.4394,
    x2: 29.5834,
    y2: 31.2687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_15268_36948",
    x1: 13.041,
    y1: 29.2408,
    x2: 15.8381,
    y2: 21.2865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_15268_36948",
    x1: 12.9006,
    y1: 27.0225,
    x2: 43.7075,
    y2: 27.0225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_15268_36948",
    x1: 24.8783,
    y1: 26.4831,
    x2: 33.3647,
    y2: 21.0023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#FE9C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_15268_36948",
    x1: 89.1711,
    y1: 85.6435,
    x2: 93.1582,
    y2: 76.9605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_15268_36948",
    x1: 80.4378,
    y1: 81.4659,
    x2: 90.997,
    y2: 82.7857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_15268_36948",
    x1: 98.9695,
    y1: 78.4957,
    x2: 99.3978,
    y2: 69.1577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_15268_36948",
    x1: 87.5128,
    y1: 79.2463,
    x2: 95.8237,
    y2: 77.4966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_15268_36948",
    x1: 104.989,
    y1: 70.1809,
    x2: 102.331,
    y2: 60.9244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_15268_36948",
    x1: 94.1306,
    y1: 76.0073,
    x2: 102.486,
    y2: 70.9059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_15268_36948",
    x1: 106.844,
    y1: 62.3398,
    x2: 102.313,
    y2: 54.2024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_15268_36948",
    x1: 100.519,
    y1: 70.2653,
    x2: 107.927,
    y2: 62.8573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_15268_36948",
    x1: 107.797,
    y1: 56.4889,
    x2: 101.434,
    y2: 47.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_15268_36948",
    x1: 103.811,
    y1: 64.859,
    x2: 109.358,
    y2: 57.2863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_15268_36948",
    x1: 103.957,
    y1: 48.3096,
    x2: 97.2717,
    y2: 42.2488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_15268_36948",
    x1: 108.884,
    y1: 57.3477,
    x2: 112.393,
    y2: 49.7153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_15268_36948",
    x1: 101.532,
    y1: 41.5912,
    x2: 93.0649,
    y2: 37.2691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_15268_36948",
    x1: 113.441,
    y1: 48.6776,
    x2: 115.008,
    y2: 40.3197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_15268_36948",
    x1: 98.3311,
    y1: 36.3325,
    x2: 88.3901,
    y2: 33.9571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_15268_36948",
    x1: 111.015,
    y1: 38.4953,
    x2: 110.327,
    y2: 28.6065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_15268_36948",
    x1: 92.6507,
    y1: 31.4394,
    x2: 84.6183,
    y2: 31.2687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_15268_36948",
    x1: 101.146,
    y1: 29.2408,
    x2: 98.3491,
    y2: 21.2865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_15268_36948",
    x1: 101.282,
    y1: 27.0225,
    x2: 70.4748,
    y2: 27.0225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_15268_36948",
    x1: 89.3175,
    y1: 26.4831,
    x2: 80.8311,
    y2: 21.0023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#FE9C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FEB801"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_15268_36948",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.0931 122.727) scale(47.2997 1.70829)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E2723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_15268_36948",
    x1: 35.624,
    y1: 101.008,
    x2: 35.624,
    y2: 129.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_15268_36948",
    x1: 23.7281,
    y1: 108.175,
    x2: 39.4086,
    y2: 87.8396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_15268_36948",
    x1: 29.4332,
    y1: 97.3314,
    x2: 29.4332,
    y2: 106.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#FFE7AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#FFE091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_15268_36948",
    x1: 13.9804,
    y1: 103.415,
    x2: 13.9804,
    y2: 105.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_15268_36948",
    x1: 46.5681,
    y1: 103.415,
    x2: 46.5681,
    y2: 105.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_15268_36948",
    x1: 13.9804,
    y1: 118.419,
    x2: 13.9804,
    y2: 120.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_15268_36948",
    x1: 46.5681,
    y1: 118.419,
    x2: 46.5681,
    y2: 120.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_15268_36948",
    x1: 37.7761,
    y1: 101.132,
    x2: 37.7761,
    y2: 120.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_15268_36948",
    x1: 37.2735,
    y1: 103.624,
    x2: 37.2735,
    y2: 120.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_15268_36948",
    x1: 22.2567,
    y1: 125.019,
    x2: 22.2567,
    y2: 103.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_15268_36948",
    x1: 35.4426,
    y1: 107.089,
    x2: 35.4426,
    y2: 116.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_15268_36948",
    x1: 93.2273,
    y1: 104.648,
    x2: 93.2273,
    y2: 128.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_15268_36948",
    x1: 83.3223,
    y1: 110.616,
    x2: 96.3784,
    y2: 93.6844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_15268_36948",
    x1: 88.0729,
    y1: 101.587,
    x2: 88.0729,
    y2: 109.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#FFE7AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#FFE091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_15268_36948",
    x1: 75.2065,
    y1: 106.647,
    x2: 75.2065,
    y2: 108.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_15268_36948",
    x1: 102.331,
    y1: 106.647,
    x2: 102.331,
    y2: 108.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_15268_36948",
    x1: 75.2065,
    y1: 119.144,
    x2: 75.2065,
    y2: 120.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_15268_36948",
    x1: 102.331,
    y1: 119.144,
    x2: 102.331,
    y2: 120.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_15268_36948",
    x1: 95.012,
    y1: 104.746,
    x2: 95.012,
    y2: 121.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_15268_36948",
    x1: 94.6041,
    y1: 106.821,
    x2: 94.6041,
    y2: 120.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_15268_36948",
    x1: 82.0968,
    y1: 124.636,
    x2: 82.0968,
    y2: 106.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_15268_36948",
    x1: 92.3732,
    y1: 110.6,
    x2: 92.3732,
    y2: 117.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_15268_36948",
    x1: 64.7293,
    y1: 96.2847,
    x2: 64.7293,
    y2: 130.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_15268_36948",
    x1: 50.2445,
    y1: 105.013,
    x2: 69.3371,
    y2: 80.2522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_15268_36948",
    x1: 57.1914,
    y1: 91.8094,
    x2: 57.1914,
    y2: 103.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#FFE7AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#FFE091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_15268_36948",
    x1: 38.38,
    y1: 99.2148,
    x2: 38.38,
    y2: 101.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_15268_36948",
    x1: 78.0555,
    y1: 99.2148,
    x2: 78.0555,
    y2: 101.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_15268_36948",
    x1: 38.38,
    y1: 117.486,
    x2: 38.38,
    y2: 119.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_15268_36948",
    x1: 78.0555,
    y1: 117.486,
    x2: 78.0555,
    y2: 119.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8313"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_15268_36948",
    x1: 67.354,
    y1: 96.4338,
    x2: 67.354,
    y2: 120.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_15268_36948",
    x1: 66.7516,
    y1: 99.4682,
    x2: 66.7516,
    y2: 120.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_15268_36948",
    x1: 48.4551,
    y1: 125.519,
    x2: 48.4551,
    y2: 99.5686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FEB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_15268_36948",
    x1: 68.9089,
    y1: 104.235,
    x2: 68.9089,
    y2: 115.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_15268_36948",
    x1: 85.7539,
    y1: 8.671,
    x2: 86.6985,
    y2: 29.5028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FAA38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC8E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_15268_36948",
    x1: 49.2016,
    y1: 32.1169,
    x2: 49.2016,
    y2: 26.0227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FAA38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC8E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_15268_36948",
    x1: 59.4769,
    y1: 20.1355,
    x2: 61.2687,
    y2: 20.1355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FAA38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC8E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_15268_36948",
    x1: 63.2329,
    y1: 16.1686,
    x2: 63.2329,
    y2: 28.8419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FAA38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC8E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_15268_36948",
    x1: 58.9694,
    y1: 13.9848,
    x2: 58.8104,
    y2: 19.4971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.032,
    stopColor: "#7E3C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#562710"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_15268_36948",
    x1: 66.4573,
    y1: 43.5176,
    x2: 66.4573,
    y2: 75.1538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B00A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#270094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_15268_36948",
    x1: 54.8009,
    y1: 47.4228,
    x2: 54.8009,
    y2: 54.1613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B00A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#270094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_15268_36948",
    x1: 83.5256,
    y1: 48.5428,
    x2: 83.5256,
    y2: 73.7962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B00A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#270094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_15268_36948",
    x1: 71.9647,
    y1: 26.904,
    x2: 71.9647,
    y2: 53.5823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C27B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B00A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_15268_36948",
    x1: 50.3811,
    y1: 29.2058,
    x2: 50.3811,
    y2: 35.0182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B00A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#270094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_15268_36948",
    x1: 68.6397,
    y1: 19.9519,
    x2: 72.0359,
    y2: 32.1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B00A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#270094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_15268_36948",
    x1: 51.2176,
    y1: 39.3304,
    x2: 60.3693,
    y2: 39.3304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B00A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#270094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_15268_36948",
    x1: 61.6381,
    y1: 24.8383,
    x2: 67.6771,
    y2: 24.8383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B00A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#270094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_15268_36948",
    x1: 62.514,
    y1: 31.8536,
    x2: 62.514,
    y2: 48.9579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B00A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#270094"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_15268_36948",
    x1: 68.0438,
    y1: 25.6874,
    x2: 61.1944,
    y2: 36.3545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_15268_36948",
    x1: 31.7186,
    y1: 23.7581,
    x2: 40.4851,
    y2: 23.9138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_15268_36948",
    x1: 42.3016,
    y1: 45.0088,
    x2: 38.5195,
    y2: 35.2754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_15268_36948",
    x1: 36.5761,
    y1: 47.2354,
    x2: 32.8212,
    y2: 37.5722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_15268_36948",
    x1: 47.409,
    y1: 42.9126,
    x2: 36.5481,
    y2: 14.9608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_15268_36948",
    x1: 45.5255,
    y1: 43.9982,
    x2: 41.667,
    y2: 34.0681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_15268_36948",
    x1: 49.9046,
    y1: 14.4663,
    x2: 57.2936,
    y2: 38.7346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_15268_36948",
    x1: 34.602,
    y1: 21.5689,
    x2: 45.2681,
    y2: 21.7582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_15268_36948",
    x1: 45.7508,
    y1: 18.1297,
    x2: 47.5581,
    y2: 18.1618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_15268_36948",
    x1: 39.943,
    y1: 11.6034,
    x2: 45.6672,
    y2: 28.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E99C28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_15268_36948",
    x1: 44.6529,
    y1: 33.3331,
    x2: 44.1753,
    y2: 40.4942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FAA38C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC8E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_15268_36948",
    x1: 70.9407,
    y1: 29.6672,
    x2: 67.8885,
    y2: 41.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B00A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_15268_36948",
    x1: 63.6773,
    y1: 25.0597,
    x2: 66.0514,
    y2: 35.0705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B00A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_15268_36948",
    x1: 57.1523,
    y1: 36.8235,
    x2: 57.1523,
    y2: 42.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5722"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.68b31e4ecb1b418b4ef391fefff5c5b2.svg";
export { ForwardRef as ReactComponent };